import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import { JobInfo } from "../../../../components";
import { HireJobSummary } from "../../../../api/types/job.types";
import { useGetJobDetails } from "../../../../api/queries/useGetJobDetails";
import NoCandidatesFigure from "../../../../assets/images/no-candidates-figure.png";

import JobSummary from "./JobSummary";
import { TopApplicants } from "./TopApplicants";
import { useTranslation } from "react-i18next";

const JobOverviewTab = () => {
  const { jobId } = useParams<{ jobId: string }>();

  const { data: jobDetails, isLoading: jobDetailsLoading } = useGetJobDetails(jobId);

  return (
    <Box sx={styles.sectionContainer} component="section">
      <JobSummaryContainer jobSummary={jobDetails?.data.jobSummary} jobDetailsLoading={jobDetailsLoading} />
      <JobInfo jobDetails={jobDetails?.data} isJobDetailsLoading={jobDetailsLoading} />
    </Box>
  );
};

export default JobOverviewTab;

const JobSummaryContainer = ({
  jobSummary,
  jobDetailsLoading,
}: {
  jobSummary?: HireJobSummary;
  jobDetailsLoading: boolean;
}) => {
  const CANDIDATES_COUNT = jobSummary?.allCandidates;

  if (!jobDetailsLoading && CANDIDATES_COUNT === 0) return <NoCandidatesSection />;

  return (
    <Box sx={styles.innerSectionContainer}>
      <JobSummary jobSummary={jobSummary} isJobSummaryLoading={jobDetailsLoading} />
      <TopApplicants />
    </Box>
  );
};

const NoCandidatesSection = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "jobDetailsPage.overViewTab" });
  return (
    <Box sx={styles.NoCandidatesContainer}>
      <Typography sx={styles.title}>{t("jobSummary")}</Typography>
      <Box sx={styles.noCandidatesSection}>
        <Box component="img" src={NoCandidatesFigure} sx={styles.noCandidatesFigure} />
        <Typography sx={styles.noCandidatesTitle}>{t("noCandidatesFound")}</Typography>
        <Typography sx={styles.noCandidatesDescription}>{t("noCandidatesFoundDescription")}</Typography>
      </Box>
    </Box>
  );
};

const styles = {
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflow: "hidden",
  },
  innerSectionContainer: {
    backgroundColor: "#FFF",
    borderRadius: "12px",
    border: "1px solid #EAECF0",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflow: "hidden",
  },
  NoCandidatesContainer: {
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "24px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },

  noCandidatesSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
  },
  noCandidatesFigure: {
    width: "240px",
    height: "180px",
  },
  noCandidatesTitle: {
    color: "#111",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "32px",
  },
  noCandidatesDescription: {
    color: "#5E6278",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
  },
};
